module.exports = __webpack_public_path__ + "static/media/bnaa.1be90151.png";